export class GetTableDataQualityDistributionResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<DistributionColumn>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityDistributionResponse.attributeTypeMap;
    }
    constructor() {
    }
}
